import { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme, getColor } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';

export default function FrequencyBox(props) {
  const { data } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const totalWidth = 445;

  const [lessonNameBoxWidth, setLessonNameBoxWidth] = useState(270);
  const [reserveResultBoxWidth, setReserveResultBoxWidth] = useState(94);

  const lessonNameBoxRef = useRef(null);
  const reserveResultBoxRef = useRef(null);

  // 박스 너비 측정 //
  useEffect(() => {
    setLessonNameBoxWidth(lessonNameBoxRef.current?.offsetWidth ?? 270);
    setReserveResultBoxWidth(reserveResultBoxRef.current?.offsetWidth ?? 94);
  }, [data]);

  // 시간 정리 //
  function calcLessonClassTime() {
    let tmp = data.classTime.split('-');
    let splitTmp = tmp[0].split(':');
    let splitTmp2 = tmp[1].split(':');

    let startTime = '';
    let endTime = '';

    if (parseInt(splitTmp[0]) > 12) {
      startTime = (parseInt(splitTmp[0]) - 12) + ':' + splitTmp[1] + ' PM';
    }
    else {
      startTime = splitTmp[0] + ':' + splitTmp[1] + ' AM';
    }

    if (parseInt(splitTmp2[0]) > 12) {
      endTime = (parseInt(splitTmp2[0]) - 12) + ':' + splitTmp2[1] + ' PM';
    }
    else {
      endTime = splitTmp2[0] + ':' + splitTmp2[1] + ' AM';
    }

    return startTime + ' - ' + endTime + ' : ' + data.teacherNames;
  }

  // 구분선 길이 정리 //
  function decideDivisionLineWidth() {
    return totalWidth - (lessonNameBoxWidth + reserveResultBoxWidth + 20);
  }

  return (
    <TopLevelWrapper width={totalWidth}>
      <Text fontFamily='Poppins-Medium' fontSize={12} color={theme.subText} cursor='default'>{calcLessonClassTime()}</Text>
      <InnerComponentWrapper>
        <LessonNameBox ref={lessonNameBoxRef} backgroundColor={getColor(data.color, isDark)}>
          <LessonNameWrapper>
            <LessonNameText fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subBackground}>{data.lessonName}</LessonNameText>
          </LessonNameWrapper>
        </LessonNameBox>
        <DivisionLine width={decideDivisionLineWidth()} />
        <ReserveResultBox ref={reserveResultBoxRef}>
          <ReserveResultTextWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('statistics.frequency.totalAttendees', { count: data.reserveCount })}</Text>
          </ReserveResultTextWrapper>
        </ReserveResultBox>
      </InnerComponentWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;

  gap: 4px;
`;

const InnerComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const LessonNameBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 4.5px 10px;

  max-width: 250px;
  height: 28px;

  border-radius: 4px;
  background-color: ${props => props.backgroundColor};
`;

const LessonNameWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  width: 100%;
  height: 20px;

  overflow: hidden;
`;

const LessonNameText = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;
  color: ${props => props.color};

  margin: 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DivisionLine = styled.div`
  display: flex;
  flex-direction: row;

  width: ${props => props.width}px;
  height: 1px;

  background-color: ${props => props.theme.line};
`;

const ReserveResultBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  min-width: 74px;
  height: 28px;

  border-radius: 4px;
  background-color: ${props => props.theme.line};
`;

const ReserveResultTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 28px;

  border-radius: 8px;
  background-color: ${props => props.theme.line};
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;
